export const getDataAttributes = (target: EventTarget | null): Record<string, string> => {
  if (!(target instanceof HTMLElement)) {
    return {};
  }
  const bar = target.closest<HTMLElement>("[data-type]");
  if (!bar) {
    return {};
  }
  return Object.fromEntries(
    Object.entries(bar.dataset).filter((entry): entry is [string, string] => entry[1] !== undefined)
  );
};
